import { css } from 'aphrodite';
import { overviewFieldStyles } from './overviewFieldStyles';

export interface IRenewalDateSubLinesProps {
	pendingCancellation: boolean;
	stillInContract: boolean;
}

/**
 * The sub-lines both Overview cards render under a renewal date. `pendingCancellation` doubles as
 * "this cell is `danger`-toned", which is what recolors the "Still in contract" line.
 */
export const RenewalDateSubLines = ({ pendingCancellation, stillInContract }: IRenewalDateSubLinesProps) => (
	<>
		{pendingCancellation && (
			<div className={css(overviewFieldStyles.subLinePendingCancellation)}>Pending Cancellation</div>
		)}
		{stillInContract && (
			<div className={css(overviewFieldStyles.subLine, pendingCancellation && overviewFieldStyles.subLineOnDanger)}>
				Still in contract
			</div>
		)}
	</>
);
